module.exports={"(optional)":"(необов’язково)","(required)":"(обов’язково)"};